'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Ajax = require('../xhr');
var RM = require('./model');
var Category = require('../constant/category');

var _require = require('../constant/patterns'),
    jsPattern = _require.jsPattern,
    cssPattern = _require.cssPattern,
    imgPattern = _require.imgPattern;

var Util = require('../util/index');
var util = require('../util/util');
var Event = require('../util/event');
var Logger = require('../util/logger');
var Logan = require('../util/logan');
var protocol = require('../constant/protocol');
var canIUse = require('../util/caniuse');
var CACHE_SEND_TRIGGER = 10;
var parseInt = Number.parseInt || window.parseInt;
var NAME = 'resource';

var getImageDomain = function getImageDomain(url) {
    var arr = url.split('//');
    if (arr && arr.length > 1) {
        return arr[0] + '//' + arr[1].split('/')[0] + '/images';
    }
};

var ResManager = function () {
    function ResManager(cfgManager, errManager) {
        _classCallCheck(this, ResManager);

        this.cfgManager = cfgManager;
        this.errManager = errManager;
        this.cache = [];
        this.entryCache = [];
        this.comboTimeout = 0;
        this.isSupportGetEntries = canIUse.GetEntries();
    }
    // parse xhr info


    _createClass(ResManager, [{
        key: 'parseAjax',
        value: function parseAjax(event) {
            try {
                if (!event || !event.currentTarget || isNaN(event.duration)) return;

                var state = event.type;
                var duration = event.duration;
                var byte = event.total;
                var currTarget = event.currentTarget;
                var statusCode = currTarget.status;
                var url = Util.getFullUrl(currTarget.responseURL || currTarget.url);

                if (!this.checkUrlValid(url)) return;
                if (this.checkMTSIForbid(currTarget)) return;

                var cfgManager = this.cfgManager;
                var resReg = cfgManager.get('resourceReg');
                var isUrlValid = cfgManager.get('devMode') || resReg instanceof RegExp && resReg.test(url);
                var ajaxConfig = cfgManager.get('ajax');
                var config = cfgManager.get(NAME);

                var responsetime = duration.toString();
                var traceid = currTarget.traceid || '';
                var logInfo = {
                    project: cfgManager.get('project'),
                    url: url,
                    method: currTarget.method || '',
                    duration: responsetime,
                    traceid: traceid,
                    timestamp: +new Date()
                };
                if (isUrlValid) {
                    if (!ajaxConfig.flag || duration < ajaxConfig.duration) {
                        var isSuccess = void 0;
                        var httpCode = void 0;
                        var businessCode = void 0;
                        var content = '';
                        if (config.enableStatusCheck) {
                            httpCode = statusCode || (state === 'load' ? 200 : 500);
                            isSuccess = (state === 'load' || state === 'readystatechange') && (httpCode >= 200 && httpCode < 300 || httpCode === 304);
                            if (!isSuccess) {
                                content = state === 'load' ? '' : 'from: xhr ' + state + '.';
                                content += currTarget.statusText ? httpCode + ' ' + currTarget.statusText : '';
                            }
                        } else {
                            isSuccess = state === 'load' || state === 'readystatechange' && statusCode === 200;
                            httpCode = isSuccess ? 200 : 500;
                            content = isSuccess ? '' : 'from: xhr ' + state;
                        }
                        if (isSuccess && ajaxConfig.autoBusinessCode && typeof currTarget.getResponseHeader === 'function' && typeof ajaxConfig.parseResponse === 'function') {
                            try {
                                var contentType = currTarget.getResponseHeader('Content-Type');
                                if (!contentType || !/(text)|(json)/.test(contentType)) return;
                                var responseType = currTarget.responseType;
                                var response = void 0;
                                if (!responseType || responseType === 'text') {
                                    response = currTarget.responseText;
                                } else if (responseType === 'json') {
                                    response = currTarget.response;
                                }
                                try {
                                    response = response && typeof response == 'string' ? JSON.parse(response) : response;
                                } catch (e) {}
                                var result = ajaxConfig.parseResponse(response);
                                businessCode = result.code;
                            } catch (e) {
                                Util.reportSysError(e);
                            }
                        }
                        this.pushApi({
                            type: 'ajax',
                            resourceUrl: url,
                            connectType: this.getConnectTypeByUrl(url),
                            responsetime: responsetime,
                            responsebyte: byte && byte.toString() ? byte.toString() : '0',
                            statusCode: httpCode + '|' + (typeof businessCode === 'undefined' ? '' : businessCode),
                            firstCategory: isSuccess ? '' : Category.AJAX,
                            logContent: content,
                            traceid: traceid
                        });
                        logInfo.code = httpCode;
                        var logLevel = 'info';
                        var logTag = 'ajax';
                        if (!isSuccess) {
                            logInfo.error = { type: 'default', content: content };
                            logLevel = 'error';
                            logTag = 'ajaxError';
                        }
                        Logan._log('[Ajax]:' + JSON.stringify(logInfo), 'owl', logLevel, [logTag]);
                    } else if (Math.random() < config.sampleApi) {
                        var msg = 'ajax\u8BF7\u6C42\u65F6\u95F4\u8D85\u8FC7\u8BBE\u5B9A ' + url;
                        this.errManager.push({ name: 'TIMEOUT_AJAX', msg: msg }, { category: Category.AJAX });
                        logInfo.error = { type: 'timeout', content: msg };
                        Logan._log('[Ajax]:' + JSON.stringify(logInfo), 'owl', 'error', ['ajaxError']);
                    }
                } else if (cfgManager.get('invalid').ajax && ajaxConfig.invalid && Math.random() < config.sample) {
                    this.errManager.push({ name: 'INVALID_AJAX', msg: url }, { category: Category.AJAX });
                    logInfo.error = { type: 'invalidUrl', content: url };
                    Logan._log('[Ajax]:' + JSON.stringify(logInfo), 'owl', 'error', ['ajaxError']);
                }
            } catch (e) {
                Util.reportSysError(e);
            }
        }
        // parse fetch info

    }, {
        key: 'parseFetch',
        value: function parseFetch(info) {
            try {
                var url = info.url,
                    duration = info.duration,
                    isSuccess = info.isSuccess;

                if (!url || isNaN(duration) || isSuccess === undefined) return;

                url = Util.getFullUrl(url);
                if (!this.checkUrlValid(url)) return;

                var cfgManager = this.cfgManager;
                var ajaxConfig = cfgManager.get('ajax');
                var resReg = cfgManager.get('resourceReg');
                if (!(cfgManager.get('devMode') || resReg instanceof RegExp && resReg.test(url))) return;

                if (cfgManager.get(NAME).ignoreMTSIForbidRequest && info.xForbidReason && info.statusCode === 403) return;

                Logan.log('[Fetch]:' + JSON.stringify(info), 'owl', 'error', ['ajaxError']);

                var statusCode = void 0;
                var firstCategory = void 0;
                var logContent = void 0;
                var businessCode = void 0;
                var response = info.response;
                if (isSuccess) {
                    var ok = info.ok ? true : false;
                    var defaultCode = ok ? 200 : 404;
                    statusCode = info.statusCode || defaultCode;
                    firstCategory = ok ? '' : Category.AJAX;
                    logContent = ok ? '' : statusCode + ' ' + (info.statusText || '');
                    if (ajaxConfig.autoBusinessCode) {
                        try {
                            response = response && typeof response == 'string' ? JSON.parse(response) : response;
                            var result = ajaxConfig.parseResponse(response);
                            businessCode = result.code;
                        } catch (e) {}
                    }
                } else {
                    statusCode = '500';
                    firstCategory = Category.AJAX;
                    logContent = info.errMsg || info.errName || '';
                }

                this.pushApi({
                    type: 'fetch',
                    resourceUrl: url,
                    connectType: this.getConnectTypeByUrl(url),
                    responsetime: duration.toString() || '0',
                    responsebyte: '0',
                    statusCode: statusCode + '|' + (typeof businessCode === 'undefined' ? '' : businessCode),
                    firstCategory: firstCategory,
                    logContent: logContent,
                    traceid: info.traceid
                });
            } catch (e) {
                Util.reportSysError(e);
            }
        }
    }, {
        key: 'checkUrlValid',
        value: function checkUrlValid(url) {
            try {
                var ignoreList = this.cfgManager.get('ignoreList').ajax || [];
                for (var i = 0; i < ignoreList.length; i++) {
                    var urlReg = new RegExp(ignoreList[i]);
                    if (urlReg.test(url)) return false;
                }
            } catch (e) {
                Util.reportSysError(e);
                return false;
            }
            return true;
        }
        // 过滤 MTSI 反爬拦截的请求

    }, {
        key: 'checkMTSIForbid',
        value: function checkMTSIForbid(target) {
            if (!target || !this.cfgManager.get(NAME).ignoreMTSIForbidRequest) return false;

            try {
                if (target.status === 403 && typeof target.getAllResponseHeaders === 'function') {
                    var headers = target.getAllResponseHeaders();
                    if (headers && headers.indexOf('x-forbid-reason') > -1) {
                        return true;
                    }
                }
            } catch (e) {
                Util.reportSysError(e);
            }

            return false;
        }
    }, {
        key: 'parseType',
        value: function parseType(type) {
            var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            if (!(type && url)) return '';
            // type: script link img css
            if (type === 'img' || url.match(imgPattern)) {
                type = 'image';
            } else if (type === 'script' || type === 'link' && url.match(jsPattern)) {
                type = 'js';
            } else if (type === 'css' || type === 'link' && url.match(cssPattern)) {
                type = 'css';
            }
            return type;
        }
    }, {
        key: 'filterResource',
        value: function filterResource(url) {
            try {
                var filters = this.cfgManager.get('ignoreList').resource;
                for (var i = 0; i < filters.length; i++) {
                    var tempReg = new RegExp(filters[i]);
                    if (tempReg.test(url)) return false;
                }
                return true;
            } catch (e) {
                Util.reportSysError(e);
                return false;
            }
        }
        // 解析性能条目的列表数据

    }, {
        key: 'parsePerformanceEntries',
        value: function parsePerformanceEntries(entries) {
            entries = this.filterEntries(entries);
            if (!(entries && entries.length)) return;

            var cfgManager = this.cfgManager;
            var devMode = cfgManager.get('devMode');
            var resReg = cfgManager.get('resourceReg');
            var imgConfig = cfgManager.get('image');
            var entryCache = this.entryCache;
            for (var i = 0; i < entries.length; i++) {
                var entry = entries[i];
                var url = entry.name;
                var urlValid = this.filterResource(url);
                if (!(urlValid && (devMode || resReg instanceof RegExp && resReg.test(url)))) continue;

                entryCache.push(url);
                var hasError = false;
                var type = this.parseType(entry.initiatorType, url);
                var isImg = type === 'image';
                var duration = parseInt(entry.duration || 0) || 0;
                if (imgConfig.flag && isImg) {
                    var filter = imgConfig.filter;
                    if (!filter || typeof filter === 'function' && !filter(url)) {
                        var sec_category = void 0;
                        var size = entry.transferSize;
                        if (size && size > imgConfig.fileSize * 1000) {
                            sec_category = 'IMAGE_SIZE_EXCEED';
                        } else if (duration && duration > imgConfig.duration) {
                            sec_category = 'IMAGE_DURATION_EXCEED';
                        }
                        if (sec_category) {
                            hasError = true;
                            this.errManager._pushResource({
                                category: Category.RESOURCE,
                                sec_category: sec_category,
                                content: url
                            });
                        }
                    }
                }
                if (!hasError) {
                    this.push({
                        type: type,
                        connectType: this.getConnectTypeByUrl(url),
                        resourceUrl: isImg ? getImageDomain(url) : url,
                        responsetime: duration.toString() || '0',
                        responsebyte: entry.transferSize && entry.transferSize.toString() || '0',
                        statusCode: '200|',
                        logContent: isImg ? url : ''
                    });
                }
            }
            this.triggerReport();
        }
    }, {
        key: 'filterEntries',
        value: function filterEntries(entries) {
            // 筛选静态资源类型
            var ret = [];
            var validList = ['link', 'script', 'img', 'css'];
            for (var i = 0; i < entries.length; i++) {
                var entry = entries[i];
                if (validList.indexOf(entry.initiatorType) > -1) {
                    ret.push(entry);
                }
            }
            return ret;
        }
        // 资源加载的动态监测

    }, {
        key: 'observeResourceTiming',
        value: function observeResourceTiming() {
            var _this = this;

            if (this.resTimingObserved) return;

            this.resTimingObserved = true;

            var disableObserver = this.cfgManager.get(NAME).disablePerformanceObserver || false;
            if (!disableObserver && canIUse.PerformanceObserver()) {
                var observer = new window.PerformanceObserver(function (list) {
                    try {
                        var entries = list.getEntries();
                        _this.parsePerformanceEntries(entries);
                    } catch (e) {
                        Util.reportSysError(e);
                    }
                });
                observer.observe({ entryTypes: ['resource'] });
            } else {
                // 通过响应 ajax 请求实现动态监测
                Event.on('ajaxCall', function () {
                    setTimeout(function () {
                        var entryCache = _this.entryCache;
                        var nextEntries = window.performance.getEntries();
                        if (nextEntries.length === entryCache.length) {
                            return;
                        } else if (nextEntries.length > entryCache.length) {
                            var diffEntries = [];
                            for (var i = 0; i < nextEntries.length; i++) {
                                if (entryCache.indexOf(nextEntries[i].name) === -1) {
                                    diffEntries.push(nextEntries[i]);
                                }
                            }
                            entryCache = nextEntries;
                            _this.parsePerformanceEntries(diffEntries);
                        }
                    }, 1500);
                });
            }
        }
    }, {
        key: 'handleResourceTiming',
        value: function handleResourceTiming() {
            try {
                if (this.isSupportGetEntries) {
                    var entries = window.performance.getEntries();
                    this.parsePerformanceEntries(entries);
                    this.observeResourceTiming();
                }
            } catch (e) {
                Util.reportSysWarn(e);
            }
        }
    }, {
        key: 'handleResourceLoadError',
        value: function handleResourceLoadError(event) {
            var _this2 = this;

            var target = event.target || event.srcElement;

            var doTask = function doTask() {
                var url = target.src || target.href;
                var href = Util.getHref();
                if (!url || !href || href.indexOf(url) === 0) return; // 过滤图片懒加载触发的error (url等于前部分href)

                var sec_category = (target.nodeName || '').toLowerCase();
                if (!sec_category) return;

                var urlShort = sec_category === 'img' ? getImageDomain(url) : url;
                if (!urlShort) return;

                var urlValid = _this2.filterResource(urlShort);
                if (!urlValid) return;

                if (jsPattern.test(url)) {
                    Logan._log('[Error]:' + JSON.stringify({ type: 'js', url: url }), 'owl', 'error', ['resourceError']);
                }

                var xpath = Util.getXPath(target);
                var content = url + (xpath ? '\n' + xpath : '');
                if (_this2.isSupportGetEntries) {
                    _this2.pushApi({
                        type: _this2.parseType(sec_category, url),
                        resourceUrl: urlShort,
                        connectType: _this2.getConnectTypeByUrl(urlShort),
                        responsetime: '0',
                        statusCode: '500|',
                        firstCategory: Category.RESOURCE,
                        secondCategory: sec_category,
                        logContent: content
                    });
                } else {
                    _this2.errManager._pushResource({
                        category: Category.RESOURCE,
                        sec_category: sec_category,
                        content: content
                    });
                }
            };

            try {
                if (target instanceof HTMLScriptElement || target instanceof HTMLLinkElement || target instanceof HTMLImageElement) {
                    doTask();
                }
            } catch (e) {
                Util.reportSysError(e);
            }
        }
    }, {
        key: '_stringify',
        value: function _stringify() {
            var cache = this.cache;
            if (!(cache && cache.length)) return;

            var ext = this.cfgManager.getExtension();
            var ret = {
                region: '',
                operator: '',
                network: '',
                container: '',
                os: '',
                unionId: ''
            };
            for (var key in ret) {
                if (ret.hasOwnProperty(key)) {
                    ret[key] = ext[key] || '';
                }
            }

            var infos = [];
            for (var i = 0; i < cache.length; i++) {
                infos.push(cache[i]);
            }
            ret['infos'] = infos;

            return ret;
        }
    }, {
        key: 'doBatchPush',
        value: function doBatchPush(data) {
            data = this.parse(data);
            var instance = new RM(data);
            var shouldPush = true;
            var onBatchPush = this.cfgManager.get('onBatchPush');
            if (typeof onBatchPush === 'function') {
                try {
                    shouldPush = onBatchPush(instance);
                } catch (e) {
                    Logger.ignore(e);
                }
            }
            if (!shouldPush) return;
            this.cache.push(instance);
        }
    }, {
        key: 'push',
        value: function push(resource) {
            if (Math.random() > this.cfgManager.get(NAME).sample) return;
            this.doBatchPush(resource);
            if (this.cache.length >= CACHE_SEND_TRIGGER) {
                this.report(true);
            } else {
                this.triggerReport();
            }
        }
    }, {
        key: 'parse',
        value: function parse(res) {
            res.pageUrl = res.pageUrl || this.cfgManager.get('pageUrl');
            res.project = res.project || this.cfgManager.get('project');
            res.realUrl = res.realUrl || location.href;
            return res;
        }
    }, {
        key: 'pushApi',
        value: function pushApi(api) {
            if (Math.random() > this.cfgManager.get(NAME).sampleApi) return;
            api.ctags = JSON.stringify(util.isFlatObj(api.ctags) ? api.ctags : this.cfgManager.getCustomTags());
            this.doBatchPush(api);
            this.triggerReport();
        }
    }, {
        key: 'report',
        value: function report() {
            this.triggerReport(true);
        }
    }, {
        key: 'triggerReport',
        value: function triggerReport(reportNow) {
            var _this3 = this;

            if (!this.cache.length) return;

            var comboReport = function comboReport() {
                clearTimeout(_this3.comboTimeout);
                _this3.comboTimeout = 0;
                _this3.send();
            };

            var delay = this.cfgManager.get(NAME).delay;
            if (reportNow) {
                this.send();
            } else if (!this.comboTimeout && delay !== -1) {
                this.comboTimeout = setTimeout(comboReport, delay);
            }
        }
    }, {
        key: 'send',
        value: function send() {
            var data = this._stringify();
            if (!data) return;

            var apiPath = this.cfgManager.getApiPath(NAME);
            Ajax({
                type: 'POST',
                url: apiPath + ('&pageId=' + this.cfgManager.get('pageId')),
                data: JSON.stringify(data)
            });

            this.cache = [];
        }
    }, {
        key: 'getConnectTypeByUrl',
        value: function getConnectTypeByUrl(url) {
            if (url.indexOf('https') === 0) {
                return 'https';
            } else if (url.indexOf('http') === 0) {
                return 'http';
            }
            return protocol.indexOf('https') === 0 ? 'https' : 'http';
        }
    }]);

    return ResManager;
}();

module.exports = ResManager;